<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :apiUrl="apiUrl"
      withoutDelete>

      <template #additionalButton="scope">

        <button
          class="btn btn-sm btn-primary btn-icon-split"
          :disabled="!selectedItem"
          v-b-tooltip.hover
          title="Update Potongan"
          @click="updateSalaryCut">

          <span class="icon text-white">
            <i class="fas fa-hand-holding-usd" />
          </span>
          <span class="text d-none d-lg-inline-block">Update Potongan</span>
        </button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :search="search"
      @onDblClicked="item => updateSalaryCut(item)"
      @onSelectItem="selectedItem = $event" />

    <b-modal
      id="modalUpdateSalaryCut"
      :title="`Potongan Gaji ${employeeName}`"
      header-class="bg-light text-primary py-1"
      no-close-on-backdrop
      hide-footer>

      <form @submit.prevent="submitSalary" class="d-block">
        <div class="row">
          <div class="col-6" v-for="cutType in listSalaryCutTypes" :key="cutType.ID">
            <div class="form-group">
              <label>{{ cutType.Name }}</label>
              <input
                class="form-control d-block w-100"
                v-model.number="form[cutType.Name.replace(/\s/g, '')]"
                @keypress="$helper.inputRestrictNumber(form[cutType.Name.replace(/\s/g, '')])" />
            </div>
          </div>
        </div>

        <div class="text-right">
          <button class="btn btn-primary btn-sm" type="submit">Simpan</button>
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.fetchOptionData()
  },
  data() {
    return {
      apiUrl: '/salary-cut',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Pegawai', formatter: value => value },
        { key: 'CutTotal', label: 'Total potongan', formatter: value => value ? this.$helper.formatRupiah(value) : '-' },
        
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {},
      scopedFilterData: {},
      disableEmployeeInput: false,
      form: {},
      listSalaryCutTypes: [],
      employeeName: ''
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },
    fetchOptionData () {
      this.$axios.all([
        this.$axios.get('/salary-cut-type'),
      ]).then(this.$axios.spread((...res) => {
        this.listSalaryCutTypes = res[0].data

        this.initDynamicFormAndTableField()
      }))
    },
    initDynamicFormAndTableField () {
      for (var i = this.listSalaryCutTypes.length - 1; i >= 0; i--) {
        const fieldName = this.listSalaryCutTypes[i].Name.replace(/\s/g, '')

        this.form[fieldName] = 0

        this.tableFields.push({
          key: fieldName,
          label: this.listSalaryCutTypes[i].Name,
          formatter: value => value ? this.$helper.formatRupiah(value) : '-'
        })
      }
    },
    updateSalaryCut (item) {
      item = (item.constructor === Object) ? item : this.selectedItem

      this.employeeName = item.Name

      this.form.ID = item.ID

      for (const key of Object.keys(this.form)) {
        this.form[key] = item[key]
      }

      this.$bvModal.show('modalUpdateSalaryCut')
    },
    submitSalary () {
      this.$axios.post(this.apiUrl, this.form).then(res => {
        this.onRefresh()
        this.$bvModal.hide('modalUpdateSalaryCut')
      })
    }
  }
}
</script>
